import React from "react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import { useFormContext } from "react-hook-form";
import { TFormFilter } from "@state/quick-play-store/QuickBetStore";
import { Button } from "@components/buttons";

export function QuickBetOddsGroup(props: {
	type: "maxOddValue" | "minOddValue";
	text: string;
}) {
	const { t } = useTranslation();

	const formContext = useFormContext<TFormFilter>();

	const values = formContext.getValues();
	const rootStore = useRootAppStore();

	const minOddValue = values["minOddValue"];
	const maxOddValue = values["maxOddValue"];

	const decreaseCheck =
		props.type == "minOddValue" &&
		values[props.type] -
			rootStore.quickPlayStore.quickBetStore.COEFFICIENT_CHANGE_VALUE <
			1.0;

	const minMaxCheck =
		props.type === "maxOddValue" &&
		values[props.type] -
			rootStore.quickPlayStore.quickBetStore.COEFFICIENT_CHANGE_VALUE <=
			minOddValue;

	const lessThanOrEqual100 =
		props.type === "maxOddValue" &&
		values[props.type] +
			rootStore.quickPlayStore.quickBetStore.COEFFICIENT_CHANGE_VALUE >=
			100;

	const isMinButtonDisabled =
		props.type === "minOddValue" &&
		values[props.type] +
			rootStore.quickPlayStore.quickBetStore.COEFFICIENT_CHANGE_VALUE >=
			maxOddValue;

	function changeOddValue(
		key: "maxOddValue" | "minOddValue",
		num: "increase" | "decrease"
	) {
		switch (num) {
			case "increase":
				formContext.setValue(
					key,
					values[key] +
						rootStore.quickPlayStore.quickBetStore
							.COEFFICIENT_CHANGE_VALUE
				);
				break;
			case "decrease":
				formContext.setValue(
					key,
					values[key] -
						rootStore.quickPlayStore.quickBetStore
							.COEFFICIENT_CHANGE_VALUE
				);
				break;
			default:
				console.error("missing switch value");
		}
	}

	formContext.watch(props.type);
	return (
		<>
			{formContext.formState.errors[props.type] && (
				<span>{formContext.formState.errors[props.type]?.message}</span>
			)}
			<div className="u-display--f u-display--f--col">
				<span className="bet--odd__title">{t(props.text)} :</span>
				<span className="bet--odd">
					{formContext.getValues()[props.type].toFixed(2)}
				</span>
			</div>
			<div className="u-display--f u-gap--sml">
				<Button
					type="button"
					className="btn--square btn--square--sml btn--primary--inverted btn--focus-reset"
					onClick={() => {
						changeOddValue(props.type, "decrease");
					}}
					disabled={decreaseCheck || minMaxCheck}
					iconOnly
					iconClassName="u-icon u-icon--sml u-icon--subtract"
				/>
				<Button
					type="button"
					className="btn--square btn--square--sml btn--primary--inverted btn--focus-reset"
					onClick={() => {
						changeOddValue(props.type, "increase");
					}}
					disabled={isMinButtonDisabled || lessThanOrEqual100}
					iconOnly
					iconClassName="u-icon u-icon--sml u-icon--add"
				/>
			</div>
		</>
	);
}
